import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M13 0h-2v2H5V0H3v2h-.4c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 2.76 1 3.04 1 3.6v8.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C1.76 14 2.04 14 2.6 14h2.074A7 7 0 0 1 15 5.255V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.24 2 13.96 2 13.4 2H13V0Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.889 8C9.319 8 8 9.316 8 11s1.32 3 2.889 3c.932 0 1.77-.46 2.303-1.19l1.616 1.18C13.922 15.202 12.5 16 10.888 16 8.163 16 6 13.735 6 11s2.162-5 4.889-5a4.84 4.84 0 0 1 3.787 1.838l1.32-.943.012 4.718-4.459-1.54 1.496-1.07A2.835 2.835 0 0 0 10.889 8Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconFunctionalUpdateDate16 = createIcon(IconComponent);